import axios from 'axios'
import { useAuthStore } from '../contexts/authStore'

/**
 * Setup Axios interceptors for global error handling
 * Automatically logs out user when receiving 401 (Unauthorized) responses
 */
export function setupAxiosInterceptors() {
  // Response interceptor to handle 401 errors globally
  axios.interceptors.response.use(
    (response) => {
      // Pass through successful responses
      return response
    },
    (error) => {
      // Handle 401 Unauthorized errors
      if (error.response && error.response.status === 401) {
        // Get the current path
        const currentPath = window.location.pathname

        // Don't logout if we're already on login page or public pages
        const publicPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/verify-email', '/', '/apps', '/contact']
        const isPublicPath = publicPaths.some(path => currentPath.startsWith(path))

        if (!isPublicPath) {
          // Set redirecting flag FIRST to prevent error displays
          const { setRedirecting, clearAuth } = useAuthStore.getState()
          setRedirecting()

          // Clear auth state
          clearAuth()

          // Redirect to login with return URL immediately
          const returnUrl = encodeURIComponent(currentPath)
          window.location.href = `/login?return=${returnUrl}`

          // Return a rejected promise with a special flag
          // This prevents components from showing error messages
          return Promise.reject({ ...error, isAuthRedirect: true })
        }
      }

      // Always reject the error so components can handle it if needed
      return Promise.reject(error)
    }
  )
}
